import { AfterViewInit, Component, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import * as store from 'store';

@Component({
  selector: 'mw-cookie-information',
  template: `
  <ng-template #content let-offcanvas>
	<div class="offcanvas-header">
		<h4 class="offcanvas-title">Cookies</h4>
	</div>
	<div class="offcanvas-body">
		<p>We use cookies to help us understand how the site is used.</p>
		<div class="text-end">
			<button type="button" class="btn btn-outline-secondary" (click)="acceptCookies()">Accept</button>
			<button type="button" class="btn btn-outline-secondary" (click)="rejectCookies()">Reject</button>
		</div>
	</div>
</ng-template>

<div class="cookie-information-placeholder"></div>
`,
  styles: [`

`]
})
export class CookieInformationComponent implements OnInit, AfterViewInit {
  // private offcanvasService = inject(NgbOffcanvas);
  @ViewChild('content') content: any;
  @Input() ignoreStored = false;
  @Input() application:string;
  @Output() cookieDecision = new EventEmitter<boolean>();

  closed = false;
  constructor(private offcanvasService: NgbOffcanvas) { }
  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const key = this.storageKey();
    if(key&&!this.ignoreStored){
      const alreadyConsented = store.get(key);
      if(alreadyConsented){
        this.cookieDecision.emit(true);
        return;
      }
    }

    this.offcanvasService.open(this.content,{
      position:'bottom',
      backdrop:'static' as any as boolean,
      backdropClass:'cookie-offcanvas-backdrop',
      panelClass:'h-auto',
      keyboard:false,
      beforeDismiss:()=>{
        return this.closed;
      }
    });
  }

  storageKey(): string {
    if(!this.application){
      return null;
    }

    return this.application  + '-cookie-consent';
  }

  acceptCookies(){
    const key = this.storageKey();
    if(!key){
      return;
    }

    store.set(key,true);
    this.cookieDecision.emit(true);
    this.close();
  }

  rejectCookies(){
    // ???
    this.cookieDecision.emit(false);
    this.close();
  }

  close(){
    this.closed = true;
    this.offcanvasService.dismiss();
  }
}
